const map = {
	"./Widget_BarChart.jsx": [
		"./app/Components/Dashboard/Widgets/ActualWidgets/Widget_BarChart.jsx",
		[
			"vendors-node_modules_react-chartjs-2_es_index_js",
			"app_Components_Dashboard_Widgets_ActualWidgets_Widget_BarChart_jsx"
		]
	],
	"./Widget_Doughnut.jsx": [
		"./app/Components/Dashboard/Widgets/ActualWidgets/Widget_Doughnut.jsx",
		[
			"vendors-node_modules_react-chartjs-2_es_index_js",
			"app_Components_Dashboard_Widgets_ActualWidgets_Widget_Doughnut_jsx"
		]
	],
	"./Widget_Fees.jsx": [
		"./app/Components/Dashboard/Widgets/ActualWidgets/Widget_Fees.jsx",
		[
			"vendors-node_modules_react-chartjs-2_es_index_js",
			"app_Components_Dashboard_Widgets_ActualWidgets_Widget_Fees_jsx"
		]
	],
	"./Widget_Metric.jsx": [
		"./app/Components/Dashboard/Widgets/ActualWidgets/Widget_Metric.jsx",
		[
			"app_Components_Dashboard_Widgets_ActualWidgets_Widget_Metric_jsx"
		]
	],
	"./Widget_Notification.jsx": [
		"./app/Components/Dashboard/Widgets/ActualWidgets/Widget_Notification.jsx",
		[
			"vendors-node_modules_react-collapse_lib_index_js",
			"app_Components_Dashboard_Widgets_ActualWidgets_Widget_Notification_jsx"
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./app/Components/Dashboard/Widgets/ActualWidgets lazy recursive ^\\.\\/.*\\.jsx$";
module.exports = webpackAsyncContext;